import { EFileCollection } from '@/modules/productModule/constants/productConstants'
import type { IFile } from '@/types/globalTypes'

const groupPrefix = 'news'

export const apiNews = {
	fetchSingleNews: async (newsID: number, lang = null) => {
		let url = `${groupPrefix}/${newsID}`

		const queryParams = []

		if (lang) {
			queryParams.push(`lang=${encodeURIComponent(lang)}`)
		}

		if (queryParams.length > 0) {
			url += `?${queryParams.join('&')}`
		}

		const { data } = await apiCommon<INews>(url, { method: 'GET' })
		return News(data)
	},

	fetchNews: async (page = 1, perPage = 10, search?: string, language?: string) => {
		let url = groupPrefix

		const queryParams = []

		if (perPage && page) {
			queryParams.push(`per_page=${perPage}`)
			queryParams.push(`page=${page}`)
		}

		if (search) {
			queryParams.push(`search=${encodeURIComponent(search)}`)
		}

		if (language) {
			queryParams.push(`language=${encodeURIComponent(language)}`)
		}

		if (queryParams.length > 0) {
			url += `?${queryParams.join('&')}`
		}

		const { data, links, meta } = await apiCommon<INews[]>(url, {
			method: 'GET',
		})

		if (!data) return { response: [], links, meta }

		const response = data.map((location) => {
			return News(location)
		})
		return { data: response, links, meta }
	},

	updateNews: async (newsData: Partial<INewsModel>, newsID: number) => {
		const { data } = await apiCommon<INews>(`${groupPrefix}/${newsID}`, { method: 'PUT', body: newsToJSON(newsData) })
		return News(data)
	},

	createNews: async (newsData: Partial<INewsModel>) => {
		const { data } = await apiCommon<INews>(`${groupPrefix}`, {
			method: 'POST',
			body: newsToJSON(newsData),
		})
		return News(data)
	},

	deleteNews: async (newsID: number) => {
		const data = await apiCommon<string>(`${groupPrefix}/${newsID}`, { method: 'DELETE' })
		return data
	},

	// for files
	uploadNewsImage: async (newsID: number, file: File, collection: EFileCollection) => {
		const formData = new FormData()
		formData.append('file', file, file.name)
		formData.append('collection', collection)

		const { data } = await apiCommon<{ data: IFile }>(`files/news/${newsID}`, {
			method: 'POST',
			body: formData,
		})
		return FileFromJSON(data)
	},

	deleteNewsImage: async (fileID: string) => {
		const data = await apiCommon<string>(`files/${fileID}`, {
			method: 'DELETE',
		})
		return data
	},
}
